module.exports = __webpack_public_path__ + "img/tpd_icon_active.2e4399d4.svg";